import { ProblemaCondicaoSelectFieldModel } from 'components/form/field/select/ProblemaCondicaoSelectField/ProblemaCondicaoSelectField'
import { parse } from 'date-fns'
import { calculateAge } from 'util/date/calculateAge'

import { DataProblemaFieldModel } from './DataProblemaField'
import { ProblemaCondicaoModel } from './model'

export const convertProblemaCondicao = (input: ProblemaCondicaoSelectFieldModel, dataNascimentoCidadao: LocalDate) =>
  ({
    ...problemaAttr(input, dataNascimentoCidadao),
    incluirNaListaProblemas: !!input,
    problemaCondicaoEvoluir: input,
  } as ProblemaCondicaoModel)

export const convertProblemaCondicaoByCiapCid = (
  input: ProblemaCondicaoSelectFieldModel,
  dataNascimentoCidadao: LocalDate,
  incluirNaListaProblemas?: boolean
) =>
  ((input && {
    ...problemaAttr(input, dataNascimentoCidadao),
    incluirNaListaProblemas: incluirNaListaProblemas,
  }) ||
    {}) as ProblemaCondicaoModel

export const convertDataProblema = (data: any, dataNascimentoCidadao: Date) => {
  const { years, months } = calculateAge(+dataNascimentoCidadao, data)

  return {
    data: data,
    idade: data && {
      anos: years,
      meses: months,
    },
  } as DataProblemaFieldModel
}

const problemaAttr = (input: ProblemaCondicaoSelectFieldModel, dataNascimentoCidadao: LocalDate) => ({
  problemaId: input?.id,
  ciap: input?.ciap && { id: input?.ciap.id, nome: input?.ciap.descricao, codigo: input?.ciap.codigo },
  cid: input?.cid10 && { id: input?.cid10.id, nome: input?.cid10.nome, codigo: input?.cid10.codigo },
  situacaoProblema: input?.situacao,
  dataInicio: convertDataProblema(input?.ultimaEvolucao?.dataInicio, parse(dataNascimentoCidadao)),
  dataFim: convertDataProblema(input?.ultimaEvolucao?.dataFim, parse(dataNascimentoCidadao)),
})
